// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1GJnn","col":"styles_col__oYWsB"};